/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { NavMenuGlobal } from "../NavMenu";
import { qreq } from "../../shared/qrequest";
import Globals from "../../shared/Globals";
import AppFloatingActions from "../AppFloatingActions";

class WeblinkQRCode extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        NavMenuGlobal.setPath('Link Device');
    }

    componentWillUnmount() {
        NavMenuGlobal.clearTitle();
    }


    render() {
        return <div className="container-fluid">
            <img src={Globals.serverUrl + '/api/weblink/qrcode'} alt="" />
        </div>;
    }
}

export default withParamsAndNavigate(WeblinkQRCode);